import {UrrSimulationInputRestDto} from "@/api/pharma-auth-urr/models";

export class UrrSimulationInputRestDtoModel implements UrrSimulationInputRestDto {
    email?: string | null;
    registration_code?: string | null;


    constructor() {
    }

    public static createWithDefaults(): UrrSimulationInputRestDtoModel {
        return new this();
    }
}
